import React, { useState, useEffect } from 'react';
import { useUnidadesLazyQuery } from '../graphql/queries/unidades.query';
import { UnidadesPageQuery_unidades } from '../graphql/queries/__generated__/UnidadesPageQuery';
import { useCadastrarUnidadeMutation } from '../graphql/mutations/cadastrar_unidade.mutation';
import { useDeletarUnidadeMutation } from '../graphql/mutations/deletar_unidade.mutation';
import { useEditarUnidadeMutation } from '../graphql/mutations/editar_unidade.mutation';
import { FormUnidade, FormularioUnidade } from '../components/form_unidade';
import { FormContainer } from '../components/container_form/styles';
import { FormList } from '../../shared/components/form_components/list';
import { Container } from '../components/container/styles';
import { SubContainer } from '../../shared/components/layout_components/sub_container/styles';

const UnidadePage: React.FC = () => {
  const [unidade, setUnidade] = useState<FormUnidade>();
  const [unidades, setUnidades] = useState<UnidadesPageQuery_unidades[]>([]);
  const itens_por_pagina = 25;

  const [obter_unidades, { fetchMore, loading }] = useUnidadesLazyQuery();
  const [cadastar_unidade] = useCadastrarUnidadeMutation();
  const [editar_unidade] = useEditarUnidadeMutation();
  const [deletar_unidade] = useDeletarUnidadeMutation();

  const on_submit = async (unidade: FormUnidade) => {
    if (!unidade.id_unidade) {
      const { data } = await cadastar_unidade({
        variables: {
          ...unidade,
        },
      });

      if (data) {
        setUnidades([...unidades, data.cadastrarUnidade]);

        alert('Unidade cadastrada com sucesso!');
      }
    } else {
      const { data } = await editar_unidade({
        variables: {
          ...unidade,
          id_unidade: unidade.id_unidade,
        },
      });

      if (data) {
        const index = unidades.findIndex(
          (unidade) => unidade.id_unidade === data.editarUnidade.id_unidade
        );

        if (index !== -1) {
          const unidades_atualizadas = [...unidades];
          unidades_atualizadas[index] = data.editarUnidade;
          setUnidades(unidades_atualizadas);
        }

        alert('Unidade editada com sucesso!');
      }
    }

    setUnidade(undefined);
  };

  const on_edit = (unidade: UnidadesPageQuery_unidades) => {
    setUnidade({
      id_unidade: unidade.id_unidade,
      dsc_nome_unidade: unidade.dsc_nome_unidade || '',
    });
  };

  const on_delete = async (id_unidade: number) => {
    await deletar_unidade({ variables: { id_unidade } });
    setUnidades((unidades) => unidades.filter((u) => u.id_unidade !== id_unidade));
  };

  const on_cancel_edit = () => {
    setUnidade(undefined);
  };

  const on_search = async (search: string) => {
    const { data } = await fetchMore({
      variables: {
        descricao: search,
        pagina: 1,
        itens_por_pagina,
      },
    });

    if (data) {
      setUnidades(data.unidades);
    }
  };

  const obter_dados_iniciais = async () => {
    const { data } = await obter_unidades({
      variables: {
        descricao: '',
        pagina: 1,
        itens_por_pagina,
      },
    });

    if (data) {
      setUnidades(data.unidades);
    }
  };

  useEffect(() => {
    document.title = 'SisIEC - Unidades';
    obter_dados_iniciais();
  }, []);

  return (
    <Container>
      <SubContainer flex={1}>
        <FormularioUnidade onSubmit={on_submit} onCancel={on_cancel_edit} unidade={unidade} />
      </SubContainer>

      <SubContainer flex={2}>
        <FormList
          list_name='Unidades'
          items={unidades.map((u) => ({
            data: u,
            id: u.id_unidade,
            label: u.dsc_nome_unidade || '',
          }))}
          onSearch={on_search}
          onEdit={on_edit}
          onDelete={on_delete}
          loading={loading}
        />
      </SubContainer>
    </Container>
  );
};

export { UnidadePage };
